"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _TopicRepliesCount = _interopRequireDefault(require("./TopicRepliesCount"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _TopicFooterContent = require("./TopicFooterContent");

var _TopicViewsCount = require("@insided/destination/uikit/TopicViewsCount");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var TopicFooter = function TopicFooter(props) {
  var topic = props.topic,
      showUnsubscribeBtn = props.showUnsubscribeBtn,
      handleFavoriteRemoval = props.handleFavoriteRemoval,
      userId = props.userId,
      lastContributor = props.lastContributor,
      extraSpacing = props.extraSpacing;
  var likedOrVotedByCurrentUser = topic.likedOrVotedByCurrentUser,
      publicId = topic.publicId,
      topicUrl = topic.topicUrl,
      replyCount = topic.replyCount,
      lastActivityAtRelative = topic.lastActivityAtRelative,
      unreadRepliesCount = topic.unreadRepliesCount,
      views = topic.views,
      lastReplyPublicId = topic.lastReplyPublicId,
      lastActivityAt = topic.lastActivityAt;
  var lastPostUrl = lastReplyPublicId ? "".concat(topicUrl === null || topicUrl === void 0 ? void 0 : topicUrl.destination, "?postid=").concat(lastReplyPublicId, "#post").concat(lastReplyPublicId) : topicUrl === null || topicUrl === void 0 ? void 0 : topicUrl.destination;
  return (0, _preact.h)("div", {
    className: "topic-view_footer ".concat(extraSpacing ? 'bottom_spacing' : '')
  }, showUnsubscribeBtn && (0, _preact.h)(_Tooltip.default, {
    trigger: (0, _preact.h)("i", {
      "aria-hidden": "true",
      className: (0, _classnames.default)('icon--star-full', 'icon--auto-width', 'thread-meta-item__icon', 'thread-meta-item__text--highlight', 'qa-topic-meta-favorite-icon'),
      onClick: function onClick() {
        return handleFavoriteRemoval();
      }
    }),
    tooltipMessage: (0, _translations.t)('Forum', 'thread.unsubscribe'),
    qaClasses: "qa-title-tooltip"
  }), (0, _preact.h)(_TopicFooterContent.TopicLikeVoteButtonView, {
    key: topic.id,
    topicId: topic.id,
    contentType: topic.contentType,
    votes: topic.votes,
    likes: topic.likes,
    isGuest: !userId,
    hasCurrentUserLiked: likedOrVotedByCurrentUser
  }), (0, _preact.h)("span", {
    className: (0, _classnames.default)('thread-meta-item', 'thread-meta-item--hover-highlight', 'is-hidden-S')
  }, (0, _preact.h)(_TopicViewsCount.TopicViewsCountAction, {
    href: (0, _absoluteUrlRuntime.resolveUrl)(topicUrl.destination),
    "data-track-type": "click",
    "data-element-name": "Search result topic meta link"
  }, (0, _preact.h)(_TopicViewsCount.TopicViewsCount, {
    views: views
  }))), (0, _preact.h)(_TopicRepliesCount.default, {
    replyCount: replyCount,
    unreadRepliesCount: unreadRepliesCount,
    publicId: publicId,
    lastPostUrl: lastPostUrl
  }), (0, _preact.h)("span", {
    className: (0, _classnames.default)('thread-meta-item', 'thread-meta-item--last-update', 'thread-meta-item--hover-highlight')
  }, (0, _preact.h)(_UserAvatar.default, {
    user: lastContributor,
    extraClass: "avatar--XS thread-meta-item__icon",
    showRank: true
  }), (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.last_post_relative_creation_date",
    renderAsText: true
  }, function (accessibilityLabel) {
    return (0, _preact.h)("a", {
      "data-track-type": "click",
      "data-element-name": "Search result topic post date link",
      className: "qa-topic-meta-last-post-date-link",
      href: (0, _absoluteUrlRuntime.resolveUrl)(lastPostUrl),
      "aria-label": accessibilityLabel
    }, (0, _preact.h)("time", {
      className: "thread-meta-item__text",
      dateTime: lastActivityAt ? new Date(lastActivityAt).toISOString() : undefined
    }, lastActivityAtRelative));
  })));
};

var _default = TopicFooter;
exports.default = _default;